<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.7 9H3a1 1 0 000 2h2v2a1 1 0 002 0v-2.7A1.3 1.3 0 005.7 9zM6 2a1 1 0 00-1 1v2H3a1 1 0 000 2h2.7A1.3 1.3 0 007 5.7V3a1 1 0 00-1-1zM10.3 7H13a1 1 0 000-2h-2V3a1 1 0 00-2 0v2.7A1.3 1.3 0 0010.3 7zM13 9h-2.7A1.3 1.3 0 009 10.3V13a1 1 0 002 0v-2h2a1 1 0 000-2z"/></svg>